const angular = require('angular');

module.exports = function (breakpointsService, featureService, settingsByBreakpoint, shopPageStateService, $state, $injector) {
    return {
        restrict: 'A',
        scope: false,
        controller: [
            '$scope', function ($scope) {
                this.setFooterVisibility = function (isVisible) {
                    $scope.isFooterVisible = isVisible;
                };
            }
        ],
        link(scope) {
            scope.SmallFormatCentrePanelSlideEnabled = featureService.isEnabled(featureService.features.centerPanelSlide);

            function shouldShowBothPanelsInSmallFormat(state) {
                let showBothPanelsInSmallFormat = false;

                if (state.data && state.data.showBothPanelsInSmallFormat) {
                    showBothPanelsInSmallFormat = angular.isArray(state.data.showBothPanelsInSmallFormat)
                        ? $injector.invoke(state.data.showBothPanelsInSmallFormat)
                        : state.data.showBothPanelsInSmallFormat;
                }

                return showBothPanelsInSmallFormat && scope.SmallFormatCentrePanelSlideEnabled;
            }

            scope.shouldShowCenterPanel = function () {
                return !breakpointsService.isInSmallFormat || shouldShowBothPanelsInSmallFormat($state.current);
            };

            scope.shouldShowFooter = function () {
                return !breakpointsService.isInSmallFormat && scope.isFooterVisible;
            };

            scope.shouldShowBackButton = function () {
                return breakpointsService.isInSmallFormat && scope.SmallFormatCentrePanelSlideEnabled;
            };

            scope.shouldShowStickyHeader = function () {
                return !breakpointsService.isInSmallFormat || !shopPageStateService.panels.right;
            };

            scope.isLeftPanelVisible = function () {
                // The left panel is not visible if we should show both panels in small format, because should show both panels
                // is only set to true in the child (center panel) state.
                return !breakpointsService.isInSmallFormat || !shouldShowBothPanelsInSmallFormat($state.current);
            };

            scope.breakpointService = breakpointsService;

            scope.isFooterVisible = true;
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoppagestate/panels-directive.js
 **/